import { forwardRef } from 'react';
import Lottie from 'lottie-react';
import cn from 'classnames';
import { LoaderAnimation, LoaderWhiteAnimation } from 'assets/animations';
import styles from './Button.module.css';

type Props = {
  isLoading?: boolean;
  className?: string;
  variant?: 'outline';
  href?: string;
  onClick?: (value: any) => void;
  displayDisabledUI?: boolean;
} & JSX.IntrinsicElements['button'];

export const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      isLoading,
      className,
      variant,
      href,
      onClick,
      displayDisabledUI,
      disabled,
      ...restOfProps
    },
    ref,
  ) => (
    <>
      {!href && (
        <button
          ref={ref}
          {...restOfProps}
          className={cn(
            styles.button,
            { [styles.button_outline]: variant === 'outline' },
            className,
            displayDisabledUI && styles.button_disabled,
          )}
          onClick={onClick}
          disabled={isLoading || disabled}
        >
          {isLoading ? (
            <Lottie
              animationData={!!variant ? LoaderAnimation : LoaderWhiteAnimation}
              className={styles.button__loader}
            />
          ) : (
            children
          )}
        </button>
      )}
      {href && (
        <a
          href={href}
          className={cn(
            styles.button,
            { [styles.button_outline]: variant === 'outline' },
            className,
          )}
        >
          {children}
        </a>
      )}
    </>
  ),
);

export default Button;
